import { gql } from '@apollo/client';

export const UPLOAD_FILE = gql`
  mutation uploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      id
      filename
      description
      mimetype
    }
  }
`;

export const BULK_DOWNLOAD_FILES = gql`
  query BULK_DOWNLOAD_FILES($input: BulkDownloadInput!) {
    bulkDownloadFiles(input: $input)
  }
`;

export const DOWNLOAD_FUNDING_APPLICATION_PROPOSALS = gql`
  query DOWNLOAD_FUNDING_APPLICATION_PROPOSALS($ids: [ID!]) {
    downloadFundingApplicationProposals(ids: $ids)
  }
`;
